import { isFunction } from '../types/function.js';
import * as React from 'react';
import { useCallback } from 'react';
import { Container, Label, RadioInput, Dot, Text } from './styles.js';

const Radio = ({ className , name , id , label , onClick , disabled , borderColor , dotColor , checked , value  })=>{
    const handleChange = useCallback((event)=>{
        if (onClick && isFunction(onClick)) {
            onClick(event);
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(Container, {
        className: className,
        disabled: disabled
    }, /*#__PURE__*/ React.createElement(Label, {
        htmlFor: id
    }, /*#__PURE__*/ React.createElement(RadioInput, {
        type: "radio",
        id: id,
        name: name,
        onClick: handleChange,
        disabled: disabled,
        dotColor: dotColor,
        checked: checked,
        value: value
    }), /*#__PURE__*/ React.createElement(Dot, {
        borderColor: borderColor
    }), label && /*#__PURE__*/ React.createElement(Text, null, label)));
};

export { Radio };
